/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StripeReaderPaymentStatus {
  WAITING = 'waiting',
  PAID = 'paid',
  DECLINED = 'declined',
  CANCELED = 'canceled',
}
